"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessMethodId = void 0;
var AccessMethodId;
(function (AccessMethodId) {
    AccessMethodId["APE"] = "ape";
    AccessMethodId["GOOGLE_PLAY"] = "googlePlay";
})(AccessMethodId = exports.AccessMethodId || (exports.AccessMethodId = {}));
